import type { QuoteDocument } from 'paintscout'

// Remove fields from quote so can be used as a quote template without error, and in editable mode
export function convertToTemplate({
  quote,
  key,
  smartTemplate
}: {
  quote: QuoteDocument
  key: string
  smartTemplate: boolean
}): QuoteDocument {
  return {
    ...quote,
    status: {
      history: {},
      value: 'draft',
      updated: Date.now()
    },
    sources: {},
    source: null,
    number: null,
    deal_id: null,
    _id: key,
    _rev: null,
    smartTemplate,
    type: 'quoteTemplate'
  }
}
